import axios from "axios";
import {
  STUDY_LEVEL_LIST_REQUEST,
  STUDY_LEVEL_LIST_SUCCESS,
  STUDY_LEVEL_LIST_FAIL,
  STUDY_LEVEL_CREATE_REQUEST,
  STUDY_LEVEL_CREATE_SUCCESS,
  STUDY_LEVEL_CREATE_FAIL,
} from "../constants/studyLevelConstants";
import { api2 } from "../core/api";

export const getstudylevel = () => async (dispatch) => {
  try {
    dispatch({
      type: STUDY_LEVEL_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await api2.get("/studylevel", config);

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: STUDY_LEVEL_LIST_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: STUDY_LEVEL_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: STUDY_LEVEL_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const setStudyLevel = (studyVal) => async (dispatch) => {
  try {
    dispatch({
      type: STUDY_LEVEL_CREATE_REQUEST,
    });

    dispatch({
      type: STUDY_LEVEL_CREATE_SUCCESS,
      payload: studyVal,
    });
  } catch (error) {
    dispatch({
      type: STUDY_LEVEL_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
